module.exports = __webpack_public_path__ + "static/media/Docker.5aecc5e9.png";